import { Company, Delegate, ProfileType } from '@modules/search/types'

export interface Chat {
  id: number
  type: ChatType
  senderId: Delegate['id']
  lastMessage?: ChatMessage
  name: string
  date: string
  companyAvatar?: string
  isIncoming?: boolean
  avatar?: string
  subTitle?: string
  companyName?: string
  otherParticipant?: {
    id: number
    type: ProfileType
    isAllDelegatesHidden?: string
    isHidden?: string
  }
}

export type LocalChat = Chat & { withDelegates?: number[]; eventData?: Delegate['eventData']; withCompanyId: Company['id'] }

export enum ChatType {
  'DIRECT' = 'DIRECT',
  'GROUP' = 'GROUP',
}

export interface ChatMessage {
  id: number
  content: string
  p1UserId: Delegate['id']
  chatId: Chat['id']
  updatedAt: string
  createdAt: string
  // status: /
}

export interface ChatMember {
  id: Delegate['id']
  avatar: string
  firstName: string
  lastName: string
  companyName: string
  profilePicture: string
  isHidden?: boolean
}

export enum SortChatType {
  updated = 'updated',
  unread = 'unread',
}

export interface GetChatsResponse {
  chats: Chat[]
  total: number
}

export interface GetChatMessagesResponse {
  messages: ChatMessage[]
  members: ChatMember[]
  total: number
}
